
























import Vue from "vue";
import NoData from "@/features/coreWebVitals/components/noData.vue";
export default Vue.extend({
  components: { "no-data": NoData },
  props: {
    data: { type: String, required: true },
    title: { type: String, required: true },
    explanation: { type: String, required: true },
    color: { type: String, required: true },
    sharp: { type: String, required: true },
    loading: { type: Boolean, required: true },
    isNoSelectDomain: { type: Boolean, required: true },
    isNoData: { type: Boolean, required: true },
  },
  methods: {
    dataColorStyle() {
      return { color: this.color };
    },
    fcpColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 1.8) {
        return "63d99a";
      }
      if (data > 3.0) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    lcpColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 2.5) {
        return "63d99a";
      }
      if (data > 4.0) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    fidColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 100) {
        return "63d99a";
      }
      if (data > 300) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    clsColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 0.1) {
        return "63d99a";
      }
      if (data > 0.25) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    inpColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 200) {
        return "63d99a";
      }
      if (data > 500) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    // TODO: 数値は別途確認
    ttfbColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data < 500) {
        return "63d99a";
      }
      if (data >= 1500) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    ttiColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 3.8) {
        return "63d99a";
      }
      if (data >= 7.3) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    tbtColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 200) {
        return "63d99a";
      }
      if (data >= 600) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
    siColor(data: number) {
      if (data === null) {
        return "gray";
      }
      if (data <= 3.4) {
        return "63d99a";
      }
      if (data >= 5.8) {
        return "#f58e7d";
      }
      return "#ffba40";
    },
  },
});

export type Labels = {
  publisher: string;
};
